import { filter, map, type Observable, tap } from 'rxjs';
import { openOKDialog } from '@pct-ng/feature-message-material';
import type { NoInternetConnectionError } from './no-internet-connection.error';
import { messageDialogOptionsGenerator } from '../../message-dialog-options-generator';

export function handleNoInternetConnectionError(
  i18nScope: string,
  i18nReloadKey: string,
  error: NoInternetConnectionError,
): Observable<NoInternetConnectionError> {
  return openOKDialog(
    messageDialogOptionsGenerator(`${i18nScope}.NO_INTERNET_CONNECTION`),
    i18nReloadKey,
  ).pipe(
    // Map operator is needed because of return type
    map(() => error),
    tap(() => window.location.reload()),
    // Stop app all http
    filter(() => false),
  );
}
